import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from '@angular/material/dialog';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { MatTableDataSource } from '@angular/material/table';
import { userDetalleOpLst } from 'src/app/models/userLst';
import { AlertifyService } from 'src/app/services/alertify.service';
import { DisciplinaService } from 'src/app/services/disciplina.service';
import { EmpresaService } from 'src/app/services/empresa.service';
import { OrdenCompraService } from 'src/app/services/orden-compra.service';
import { PlanService } from 'src/app/services/plan.service';
import { UserService } from 'src/app/services/user.service';
import { ComentarioOrdenCompraComponent } from '../comentario-orden-compra/comentario-orden-compra.component';

@Component({
  selector: 'app-index-detalle-orden-compra',
  templateUrl: './index-detalle-orden-compra.component.html',
  styleUrls: ['./index-detalle-orden-compra.component.scss'],
})
export class IndexDetalleOrdenCompraComponent implements OnInit {
  public dataSource: any;
  public displayedColumns: string[];
  public isLoadingResults = false;
  pageIndex: number = 0;
  pageSize: number = 10;
  length: number;
  searchString: string = '';
  public dataInput: any;
  public lstDisciplinas: any;
  public disciplinaSelect: any;
  public filtroSelect:any;
  public saldo: number = 0;
  public valOrdenTmp: number = 0;
  public lstPlanes: any;
  mesActual = 'aaa';

  @ViewChild(MatPaginator) paginator: MatPaginator;

  constructor(
    public userSvc: UserService,
    private empresaSvc: EmpresaService,
    public disciplinaSvc: DisciplinaService,
    public ordenCompraSvc: OrdenCompraService,
    public dialog: MatDialog,
    public planSvc: PlanService,
    private alertify: AlertifyService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<IndexDetalleOrdenCompraComponent>
  ) {
    this.dataInput = data;
    console.log('los datos de ingreso son: ', data);

    let ELEMENT_DATA: userDetalleOpLst[] = [];
    this.displayedColumns = [
      'nombre',
      'disciplina',
      'fecha',
      'plan',
      'estado',
      'acciones',
    ];

    this.dataSource = new MatTableDataSource<userDetalleOpLst>(ELEMENT_DATA);
  }

  ngOnInit(): void {
    //  this.getListadoHorarios(0, 10);
    this.getMesActual();
  }

  ngAfterViewInit() {
    this.empresaSvc.getSaldoEmpresa().subscribe((saldoEmp) => {
      this.saldo = saldoEmp;
    });

    this.disciplinaSvc.getDisciplinasDropdown().subscribe((disLst) => {
      console.log(disLst);
      this.lstDisciplinas = disLst;

      this.planSvc.GetPlanesDropDown().subscribe((disPlanes) => {
        console.log(disPlanes);
        this.lstPlanes = disPlanes;
        this.getUsers(0, 10);
        this.calcularValorOrden();
      });
    });
  }

  getUsers(page: number, numReg: number) {
    this.isLoadingResults = true;
    this.userSvc
      .getDeportistasPorOrdenCompra(
        page,
        numReg,
        this.searchString,
        this.dataInput,
        this.filtroSelect,
        this.disciplinaSelect,
      )
      .subscribe((result) => {
        console.log(result);

        this.dataSource = new MatTableDataSource<userDetalleOpLst>(result[0]);
        this.pageIndex = page;
        this.pageSize = numReg;
        this.length = result[1];
        this.isLoadingResults = false;

        //this.displayedColumns = ['id', 'nombre', 'email', 'documento'];
      });
  }

  getServerData(event: PageEvent) {
    console.log('click evento paginator', event);
    this.getUsers(event.pageIndex, event.pageSize);
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  onToggle(ob: MatSlideToggleChange, elemento: any) {
    console.log(ob);
    console.log(ob.checked);
    console.log(elemento);
    console.log('oc: ', this.dataInput);
    if (!ob.checked) {
      this.alertify.confirmOrCancel(
        'Al deshabilitar el deportista en la orden de compra, elimina el comentario asignado',
        () => {
          console.log('Le da a aceptar');
          this.cambioToggle(elemento, ob.checked);
        },
        () => {
          console.log('Le da a cancelar');
          ob.source.checked = true;
        }
      );
    } else {
      this.cambioToggle(elemento, ob.checked);
    }
  }

  private cambioToggle(elemento: any, estado: boolean) {
    this.ordenCompraSvc
      .editarUsuarioOrdenCompra(
        this.dataInput,
        elemento.id,
        estado,
        elemento.planId
      )
      .subscribe((result) => {
        if (result) {
          elemento.estado = estado;
          this.calcularValorOrden();
        } else {
          console.log('error al cambiar de estado');
        }
      });
  }

  onEnter() {
    console.log('boton enter');
    this.getUsers(0, 10);
  }

  cambioDiscipinaBuscar() {
    this.getUsers(this.pageIndex, this.pageSize);
  }

  cambioPlan(planId: any, deportista: any) {
    console.log('deportista:', deportista.id);
    console.log('planId:', planId);
    deportista.planId = planId;

    if (planId == '') {
      deportista.planId = null;
      console.log('se debe deshabilitar');
      this.cambioToggle(deportista, false);
    } else {
      console.log('se debe habilitar');
      this.cambioToggle(deportista, true);
    }
  }

  calcularValorOrden() {
    this.ordenCompraSvc.getValorOrdenCompraAbierta(this.dataInput).subscribe(
      (valOC) => {
        console.log('el valor de la OC es: ', valOC);
        this.valOrdenTmp = valOC;
      },
      (err) => {
        this.valOrdenTmp = 0;
      }
    );
  }

  comentario(elemento: any) {
    console.log(elemento);
    this.dialog.open(ComentarioOrdenCompraComponent, {
      data: {
        ordenCompraId: this.dataInput,
        usuarioId: elemento.id,
      },
    });
  }

  getMesActual() {
    const fecha = new Date();
    console.log('mes: ',fecha.getMonth())
    switch (fecha.getMonth()) {
      case 0:
        this.mesActual = 'Enero';
        break;
      case 1:
        this.mesActual = 'Febrero';
        break;
      case 2:
        this.mesActual = 'Marzo';
        break;
      case 3:
        this.mesActual = 'Abril';
        break;
      case 4:
        this.mesActual = 'Mayo';
        break;
      case 5:
        this.mesActual = 'Junio';
        break;
      case 6:
        this.mesActual = 'Julio';
        break;
      case 7:
        this.mesActual = 'Agosto';
        break;
      case 8:
        this.mesActual = 'Septiembre';
        break;
      case 9:
        this.mesActual = 'Octubre';
        break;
      case 10:
        this.mesActual = 'Noviembre';
        break;
      case 11:
        this.mesActual = 'Diciembre';
        break;
    }
  }
}
